export const EXISTING_ANALYSIS_DIALOG_TITLE = 'Godkänd analys finns redan'